
import React from "react";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { NursingHome } from "@/hooks/use-nursing-home";

interface OwnerPageHeaderProps {
  nursingHome: NursingHome;
}

export function OwnerPageHeader({ nursingHome }: OwnerPageHeaderProps) {
  return (
    <>
      <div className="mb-6">
        <Link 
          to="/owner/dashboard"
          className="inline-flex items-center text-sm text-muted-foreground hover:text-foreground"
        >
          <ArrowLeft className="h-4 w-4 mr-1" />
          Back to Dashboard
        </Link>
      </div>
      
      <div className="mb-6">
        <h1 className="text-2xl font-bold tracking-tight mb-1">{nursingHome.center_name}</h1>
        <p className="text-muted-foreground">
          Manage your nursing home profile and inquiries
        </p>
      </div>
    </>
  );
}
